import { NgModule } from '@angular/core'
import { SharedModule } from '../../core/modules/shared.module'
import { DashboardModule } from './dashboard/dashboard.module'
import { AdministrationsModule } from './administrations/administrations.module'
import { UsersModule } from './users/users.module'
import { ProspectsModule } from './prospect/prospect.module'
import { SystemModule } from './system/system.module'
import { LedgerModule } from './ledger/ledger.module'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../authentication/auth.guard'
import { AdministrationComponent } from './administrations/administration.component'
import { UserComponent } from './users/user.component'
import { RedirectComponent } from './redirect/redirect.component'
import { AdministrationService } from '../services/administration.service'
import { AdministrationDetailsComponent } from './administrations/administration-details/administration-details.component'
import { DocumentsModule } from './documents/documents.module'
import { ProspectsComponent } from './prospects/prospects.component'
import { TrackProspectsService } from '../services/track.prospects.service'
import { UserService } from '../services/user.service'

const routes: Routes = [
  {
    path: 'administrations',
    component: AdministrationComponent,
    canActivate: [AuthGuard],
    resolve: {
      administrationResponse: AdministrationService,
    },
  },
  {
    path: 'administrations/search/:searchQuery',
    component: AdministrationComponent,
    canActivate: [AuthGuard],
    resolve: {
      administrationResponse: AdministrationService,
    },
  },
  {
    path: 'administrations/:administrationId',
    component: AdministrationDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      administration: AdministrationService,
    },
  },
  {
    path: 'administrations/:administrationId/:view',
    component: AdministrationDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      administration: AdministrationService,
    },
  },
  {
    path: 'users',
    component: UserComponent,
    canActivate: [AuthGuard],
    resolve: {
      users: UserService,
    },
  },
  {
    path: 'users/role/:role',
    component: UserComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'users/status/:state',
    component: UserComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'redirect',
    component: RedirectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'prospects',
    component: ProspectsComponent,
    canActivate: [AuthGuard],
    resolve: {
      prospects: TrackProspectsService,
    },
  },
  {
    path: 'prospects/:view',
    component: ProspectsComponent,
    canActivate: [AuthGuard],
    resolve: {
      prospects: TrackProspectsService,
    },
  },
]

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    SharedModule,
    DashboardModule,
    AdministrationsModule,
    UsersModule,
    ProspectsModule,
    SystemModule,
    LedgerModule,
    DocumentsModule,
    ProspectsModule,
  ],
  providers: [TrackProspectsService],
  declarations: [RedirectComponent, ProspectsComponent],
})
export class ContentModule {}



// WEBPACK FOOTER //
// ./src/app/main/content/content.module.ts